import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Referral extends Model<Schemas['referrals'], Models> {
    get adminRoute() {
        return {
            name: 'users.profile',
            params: { id: this.id },
        };
    }
}
